import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {GrMail} from 'react-icons/gr'
import {AiFillGithub} from "react-icons/ai";
import { FaLinkedinIn, FaTwitter, FaMedium, FaYoutube } from "react-icons/fa";

function Footer() {
  // let date = new Date();
  // let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright"></Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">

          <li className="social-icons">
              <a
                href="mailto:deeppatel2.2312@gmail.com"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <GrMail />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://github.com/deeppatel23"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/deep-patel-92b95b1a3"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://twitter.com/pateldeep_23"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://deeppatel23.medium.com/"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaMedium />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.youtube.com/@deepcodes"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            </li>

            {/* <li className="social-icons">
              <a
                href="tel:+919820260178"
                style={{ color: "#222" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillPhone />
              </a>
            </li> */}
          </ul>
        </Col>
      </Row>
      {/* <h6>Made by Deep</h6> */}
    </Container>
  );
}

export default Footer;
